import { createFileRoute, notFound } from "@tanstack/react-router";
import { LITIGATION_QA, LITIGATION_QA_BY_SLUG, LITIGATION_REVIEWED_ISO, LITIGATION_REVIEWED_TH } from "@/data/litigation/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = { base: "/litigation", label: "ว่าความและระงับข้อพิพาท", reviewedIso: LITIGATION_REVIEWED_ISO, reviewedTh: LITIGATION_REVIEWED_TH };

export const Route = createFileRoute("/litigation/q/$slug")({
  loader: ({ params }) => { if (!LITIGATION_QA_BY_SLUG[params.slug]) throw notFound(); return { slug: params.slug }; },
  head: ({ loaderData }) => clusterQaDetailHead(M, loaderData ? LITIGATION_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = LITIGATION_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={LITIGATION_QA} />;
}
